// node_modules
import {
    createContext,
    useState,
} from "react";
// Types
import { TModelledTopicDTO } from "Types";

type TTopicModellingSearchContext = {
    modelledTopics: TModelledTopicDTO[],
    setModelledTopics: (newModelledTopics: TModelledTopicDTO[]) => void,
    selectedModelledTopic: TModelledTopicDTO | undefined,
    setSelectedModelledTopic: (newSelectedModelledTopic: TModelledTopicDTO | undefined) => void,
    isTopicModellingSearchStarted: boolean,
    setIsTopicModellingSearchStarted: (isStarted: boolean) => void
}

export const TopicModellingSearchContext = createContext<TTopicModellingSearchContext>({} as TTopicModellingSearchContext);

export const TopicModellingSearchProvider = ({ children }: any) => {
    // State
    const [modelledTopics, setModelledTopics] = useState<TModelledTopicDTO[]>([]);
    const [selectedModelledTopic, setSelectedModelledTopic] = useState<TModelledTopicDTO | undefined>(undefined);
    const [isTopicModellingSearchStarted, setIsTopicModellingSearchStarted] = useState<boolean>(false);

    return (
        <TopicModellingSearchContext.Provider value={{ modelledTopics, selectedModelledTopic, setModelledTopics, setSelectedModelledTopic, isTopicModellingSearchStarted, setIsTopicModellingSearchStarted }}>
            {children}
        </TopicModellingSearchContext.Provider>
    );
};